module.exports = __webpack_public_path__ + "img/Hi-Life.4e2dad1c.svg";